import request from '@/common/http/request'

// 获取奖励中心奖金统计
export function getBonusIndexTotal(data) {
    return request({
        url: '/bonus/bonusIndexTotal',
        method: 'post',
        data
    })
}
// 查询用户优惠明细分页
export function getBonusDetailsPage(data) {
    return request({
        url: '/member/bonusDetailsPage',
        method: 'post',
        data
    })
}
// 用户领取红包活动
export function getDrawDown(data) {
    return request({
        url: '/redEnvelopePromotion/drawDown',
        method: 'post',
        data
    })
}
// 用户领取红包活动记录
export function getDrawRecord(data) {
    return request({
        url: '/redEnvelopePromotion/recordList',
        method: 'post',
        data
    })
}
// 充值优惠详情
export function getRechargelist(data) {
    return request({
        url: '/setRecharge/rechargelist',
        method: 'post',
        data
    })
}
// 手机端获取活动列表（全部）
export function getEventAllList(data) {
    return request({
        url: '/eventManage/eventAllList',
        method: 'post',
        data
    })
}
// 根据红包编号查询红包
export function getRedEnvelopeDetail(data) {
    return request({
        url: '/redEnvelopePromotion/getInfoByCode',
        method: 'post',
        data
    })
}
// 用户领取红包活动
export function getRedEnvelope(data) {
    return request({
        url: '/memberRedPacket/homeRobRedPacket',
        method: 'post',
        data
    })
}
